module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Muntogna_da_Schons_COA-5127b517db33b3a741a1e73472326de1.svg";